function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M74.902,83.385l-7.11-44.038C65.33,22.589,54.434,11.017,40.29,9.733V3c0-1.657-1.343-3-3-3 c-1.656,0-3,1.343-3,3v6.767C20.322,11.213,9.591,22.729,7.156,39.305l-7.117,44.08c-0.142,0.869,0.106,1.756,0.678,2.425 c0.57,0.669,1.405,1.054,2.283,1.054h0.003c5.461-0.005,12.095-0.01,19.063-0.015C23.322,94.299,29.803,100,37.605,100 c7.808,0,14.291-5.707,15.542-13.164c10.157-0.002,17.681,0.004,18.604,0.022c0.062,0.004,0.125,0.006,0.188,0.006 c0.266,0,0.533-0.034,0.801-0.108C74.215,86.349,75.146,84.897,74.902,83.385 M37.605,94c-4.481,0-8.259-3.035-9.408-7.155 c6.404-0.005,12.883-0.007,18.819-0.009C45.87,90.961,42.09,94,37.605,94 M61.159,80.836c-6.466,0-15.083,0-23.7,0.004 c-12.512,0.006-25.021,0.016-30.936,0.021l6.563-40.642C15.282,25.27,24.783,15.61,37.29,15.61h0.36 c12.508,0,22.009,9.66,24.211,24.651l6.554,40.583C66.568,80.84,64.085,80.838,61.159,80.836"
});

var SvgNotifica = function SvgNotifica(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 76,
    height: 101,
    viewBox: "-0.436 -0.924 76 101",
    enableBackground: "new -0.436 -0.924 76 101",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotifica, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notifica.8c3c8016.svg";
export { ForwardRef as ReactComponent };